import React, { useContext, useState } from 'react';
import SearchInput from './SearchInput';
import LinkedMenu from './LinkedMenu';
import { HistoryStateContext } from '../providers/HistoryProvider';
import { TabStateContext } from '../providers/TabProvider';
import { SearchStateContext, SearchDispatchContext } from '../providers/SearchProvider';
import useFetch from '../hooks/useFetch';

export default function SearchContainer() {
  const historyState = useContext(HistoryStateContext);
  const tabState = useContext(TabStateContext);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showSearchMenu, setShowSearchMenu] = useState(false);
  const { url } = historyState[tabState.activeTab].current;
  const needFocus = !url ? Math.floor(Math.random() * 100) : 0;
  const searchState = useContext(SearchStateContext);
  const searchDispatch = useContext(SearchDispatchContext);
  const [search, setSearch] = useState(url)

  useFetch('/search.json', (data) => {
    searchDispatch({ type: 'init', data });
  });

  const onChange = (e) => {
    setShowSearchMenu(!!e.currentTarget.value);
    setSearch(e.currentTarget.value);
  }

  const handleClickOutside = () => {
    setShowSearchMenu(false);
  }

  const handleKeyDown = (e) => {
    const len = searchState.items.length + 1;
    switch (e.key) {
      case 'ArrowDown': {
        e.preventDefault();
        setSelectedIndex(selectedIndex + 1 < len ? selectedIndex + 1 : len - 1);
        break;
      }
      case 'ArrowUp': {
        e.preventDefault();
        setSelectedIndex(selectedIndex - 1 >= 0 ? selectedIndex - 1 : 0);
        break;
      }
    }
  }

  return (
    <LinkedMenu
      trackWidth={true}
      show={showSearchMenu}
      className="search-menu"
      onClickOutside={handleClickOutside}
    >
      <SearchInput
        menuShown={showSearchMenu}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        onBlur={handleClickOutside}
        needFocus={needFocus}
        value={url}>
      </SearchInput>
      <div key={0} className={`menu-item ${selectedIndex === 0 ? 'menu-accent' : ''} menu-item--selectable`}>
        <i className="icofont-license"></i>
        <span className="menu-item__title">{search} <span style={{ color: '#BEC1C5' }}>- Search Value</span></span>
      </div>
      {
        searchState.items.map((item, index) => {
          return (
            <div key={item.id} className={`menu-item ${index + 1 === selectedIndex ? 'menu-accent' : ''} menu-item--selectable`}>
              <i className="icofont-earth"></i>
              <span className="menu-item__title">{item.url}</span>
            </div>
          );
        })
      }
    </LinkedMenu>
  )
}
